<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */
 -->

<template>
  <oxd-input-field
    type="select"
    :label="$t('general.status')"
    :options="options"
  />
</template>

<script>
import {ref} from 'vue';
export default {
  name: 'StatusDropdown',
  data() {
    const options = ref([
      {
        id: 'INITIATED',
        label: this.$t('草稿'),
      },
      {
        id: 'SUBMITTED',
        label: this.$t('已提交'),
      },
      {
        id: 'APPROVED',
        label: this.$t('已批准'),
      },
      {
        id: 'REJECTED',
        label: this.$t('已拒絕'),
      },
      {
        id: 'CANCELLED',
        label: this.$t('已取消'),
      },
      {
        id: 'PAID',
        label: this.$t('已付款'),
      },
    ]);
    return {
      options,
    };
  },
};
</script>
